import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = ({ onAction }) => {
  const actions = [
    { id: 'schedule', label: 'Schedule Appointment', icon: 'Calendar', variant: 'default' },
    { id: 'order-lab', label: 'Order Lab', icon: 'FlaskConical', variant: 'outline' },
    { id: 'prescribe', label: 'Prescribe Medication', icon: 'Pill', variant: 'outline' },
    { id: 'add-note', label: 'Add Clinical Note', icon: 'FileText', variant: 'outline' },
    { id: 'view-chart', label: 'View Full Chart', icon: 'ClipboardList', variant: 'outline' },
    { id: 'send-message', label: 'Send Message', icon: 'Mail', variant: 'outline' }
  ];

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 md:mb-6">Quick Actions</h3>
      <div className="grid grid-cols-1 gap-2 md:gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            fullWidth
            iconName={action?.icon}
            iconPosition="left"
            onClick={() => onAction(action?.id)}
            className="justify-start"
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;